var render = function render(){var _vm=this,_c=_vm._self._c;return _c('food-allergies-template',{attrs:{"food-allergies":_vm.foodAllergies,"other-food-allergies":_vm.otherFoodAllergies,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }